















































































import { Component, Vue } from "vue-property-decorator";
import SoundManagerONP from "../SoundManagerONP";

@Component<Cutscene2>({})
export default class Cutscene2 extends Vue {
  private showInput: boolean = false;

  public clicked(): void {
    SoundManagerONP.btnSound();
    const inputText: any = document.getElementById("inputText");
    if (inputText.value == "") {
      inputText.placeholder = this.$i18n.t("message.placeholder");
      alert(this.$i18n.t("message.warnName"));
      return;
    }
    SoundManagerONP.playBGM();
    this.$emit("name", inputText.value);
    this.$emit("next", this);
  }
  mounted(): void {
    //button disabled
    if (this.$i18n.locale == "en") {
      const target: any = this.$refs.iText;
      target.style.left = "60px";
    }
    const target: any = this.$refs.om;
    target.style.visibility = "visible";

    const target2: any = this.$refs.om2;
    target2.style.visibility = "hidden";
    this.showInput = false;
    setTimeout((): void => {
      //button enabled
      this.showInput = true;
      const target: any = this.$refs.om;
      target.style.visibility = "hidden";

      const target2: any = this.$refs.om2;
      target2.style.visibility = "visible";
    }, 2000);
  }
}
